import z from "zod"

export const AuthData = z.object({
	userId: z.string(),
})
export type AuthData = z.infer<typeof AuthData>

export function assertIsLoggedIn(
	authData: AuthData | undefined,
): asserts authData {
	if (!authData) {
		throw new Error("User must be logged in for this operation")
	}
}

declare module "@rocicorp/zero" {
	interface DefaultTypes {
		context: AuthData
	}
}
